jQuery(document).ready(function ($) {
  
	$('.employees__collapse--more').on('click', function () {
    $('.employees').addClass('show-more');
	});
  $('.employees__collapse--less').on('click', function () {
    $('.employees').removeClass('show-more');
	});
});